export const API = {
  PREFERRED_PROGRAMMES: {
    GET_OWNERS: "/api/preferred-programmes/:venueId/programme-owners",
    ADD_GROUP: "/api/preferred-programmes/:id/add-group",
  },
  MY_PREFERRED_PROGRAMMES: "/api/my-preferred-programmes",
};
